import { hot } from 'react-hot-loader/root';
import React, { Fragment } from 'react';
import Moment from 'react-moment';
import { YMInitializer } from 'react-yandex-metrika';
import AppRouter from '../../routes/AppRouter';
import IntlProvider from '@hoc/IntlProvider';
import { Provider } from 'react-redux';
import 'moment-timezone';
import { setConfig } from 'react-hot-loader';
import { applyThemeClass, getEffectiveTheme } from '../../utils/themeStorage';
setConfig({ logLevel: 'debug' });

const App = ({ timezone = 'UTC', store, defaultLocale }) => {
  Moment.globalTimezone = timezone;
  const {
    webmaster: {
      profile: { theme, language, documents },
      logoutFetching,
    },
  } = store.getState();
  const effectiveTheme = getEffectiveTheme(theme);
  applyThemeClass(effectiveTheme);
  return (
    <Provider store={store}>
      <Fragment>
        <IntlProvider
          key={language}
          locale={language}
          defaultLocale={defaultLocale}
          textComponent={Fragment}
        >
          <AppRouter
            documents={documents}
            language={language}
            theme={effectiveTheme}
            logoutFetching={logoutFetching}
          />
        </IntlProvider>
        <YMInitializer
          accounts={[53344675]}
          options={{
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
          }}
          version="2"
        />
      </Fragment>
    </Provider>
  );
};

export default hot(App);
